import { addUserAddressArgsToParams } from 'data/api/transformers/arguments/add-user-address-args-to-params'
import { AddUserAddressArgs } from 'types/api/arguments/add-user-address-args'
import { UserAddressResp } from 'types/api/response/user-address-resp'

import { api } from './api'

export const addAddress = (args: AddUserAddressArgs) =>
  api.post<UserAddressResp>('/user_addresses', {
    user_address: addUserAddressArgsToParams(args),
    is_single_checkout: args.isSingleCheckout,
    ...(args.skipShippingCallback && { skip_shipping_callback: args.skipShippingCallback }),
  })
